export const DEFAULT_AVATAR = '/images/avatar.png'

/**
 * Resolve avatar URL from Supabase Auth user_metadata.
 * Google often sends `picture`; some providers use `avatar_url`.
 */
export const resolveAuthAvatarUrl = (userMetadata = {}) =>
  userMetadata.avatar_url || userMetadata.picture || null

/**
 * Safe src for <img>: remote URL or local fallback.
 */
export const getAvatarSrc = (avatarUrl) => avatarUrl || DEFAULT_AVATAR

/**
 * Swap to local fallback if the remote image fails (e.g. Google CDN).
 */
export const handleAvatarError = (event) => {
  const img = event?.currentTarget
  if (!img || img.dataset.fallbackApplied === 'true') return
  img.dataset.fallbackApplied = 'true'
  img.src = DEFAULT_AVATAR
}
